import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { sCurve } from "../lib/trends";
import { formatDate } from "../lib/api";

const COLORS = ["#38bdf8", "#34d399", "#f472b6", "#a78bfa", "#fb923c", "#facc15"];

export const SCurveChart = ({ state, logs }) => {
  const data = sCurve(state, logs);
  return (
    <div data-testid="s-curve-card" className="panel p-5">
      <div className="label">Cumulative weighted progress (%) per team</div>
      {data.length === 0 ? (
        <p data-testid="s-curve-empty" className="py-16 text-center text-sm text-[color:var(--muted)]">No daily logs yet. Add daily logs to build the S-curve.</p>
      ) : (
        <div data-testid="s-curve-chart" className="mt-4 h-[360px]">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 10, right: 20, left: -10, bottom: 0 }}>
              <CartesianGrid stroke="#1f293d" strokeDasharray="3 3" />
              <XAxis dataKey="date" tickFormatter={formatDate} stroke="#9ca3af" fontSize={11} />
              <YAxis domain={[0, 100]} unit="%" stroke="#9ca3af" fontSize={11} />
              <Tooltip labelFormatter={formatDate} formatter={(v) => `${v}%`} contentStyle={{ background: "#111827", border: "1px solid #1f293d", fontSize: 12 }} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              {state.teams.map((t, i) => (
                <Line key={t.id} type="monotone" dataKey={t.id} name={t.name} stroke={COLORS[i % COLORS.length]} strokeWidth={2} dot={{ r: 3 }} />
              ))}
              <Line type="monotone" dataKey="overall" name="Overall" stroke="#f59e0b" strokeWidth={3} strokeDasharray="6 3" dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
      <p className="mt-3 font-mono text-[11px] text-[color:var(--muted)]">Each point uses the latest logged progress per job up to that date, weighted by job weight.</p>
    </div>
  );
};
